module.exports = __webpack_public_path__ + "static/media/photo21.b97349c4.jpg";